import { http, createConfig, createStorage } from '@wagmi/core';
import { injected } from '@wagmi/connectors';
import { environment } from '../../../environments/environment';

const chains = [
  environment.networks.BSC.chain,
  environment.networks.ETH.chain,
];

export const wagmiConfig = createConfig({
  chains: chains as any,
  connectors: [
    injected({
      target: 'metaMask',
    }),
  ],
  storage: createStorage({ storage: window.localStorage }),
  transports: {
    [environment.networks.BSC.chain.id]: http(environment.networks.BSC.rpc),
    [environment.networks.ETH.chain.id]: http(environment.networks.ETH.rpc),
  },
});